(function() {
  function initSection(section, sectionId, enableSticky) {
    var tabSwiper = null;
    var tabItems = section.querySelectorAll('.magnet-tab-item');
    var header = document.querySelector('header') || document.querySelector('.shopify-section--header');
    var swiperEl = section.querySelector('.magnet-tab-swiper');

    function getTargetSectionByOrder(order) {
      var shopifySections = document.querySelectorAll('main > .shopify-section');
      var index = parseInt(order, 10) - 1;
      if (index < 0 || index >= shopifySections.length) return null;
      return shopifySections[index];
    }

    function updateActiveTab(order) {
      tabItems.forEach(function(item) {
        if (item.getAttribute('data-order') === String(order)) {
          item.classList.add('is-active');
          if (tabSwiper && typeof tabSwiper.slideTo === 'function') {
            var slideIndex = Array.prototype.indexOf.call(tabItems, item);
            if (slideIndex !== -1) tabSwiper.slideTo(slideIndex, 300);
          }
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    tabItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var order = this.getAttribute('data-order');
        var targetElement = getTargetSectionByOrder(order);

        if (targetElement) {
          var headerHeight = header ? header.offsetHeight : 0;
          var sectionHeight = section.offsetHeight;
          var offset = headerHeight + sectionHeight;
          var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
          updateActiveTab(order);
        }
      });
    });

    var observerOptions = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var shopifySections = document.querySelectorAll('main > .shopify-section');
        var index = Array.prototype.indexOf.call(shopifySections, entry.target);
        if (index !== -1) updateActiveTab(String(index + 1));
      });
    }, observerOptions);

    var shopifySections = document.querySelectorAll('main > .shopify-section');
    shopifySections.forEach(function(el) { observer.observe(el); });

    if (typeof Swiper !== 'undefined' && swiperEl && !swiperEl.swiper) {
      var isDesktop = window.innerWidth >= 1001;
      tabSwiper = new Swiper(swiperEl, {
        slidesPerView: isDesktop ? 'auto' : 4.5,
        spaceBetween: isDesktop ? 24 : 8,
        freeMode: false,
        resistance: true,
        resistanceRatio: 0.85,
        touchRatio: 1,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          1001: {
            slidesPerView: 'auto',
            spaceBetween: 55
          }
        }
      });
    }

    if (enableSticky) {
      var sectionElement = document.querySelector('#shopify-section-' + sectionId);
      function updateStickyPosition() {
        if (!sectionElement) return;
        var h = document.querySelector('store-header') || document.querySelector('header') || document.querySelector('.shopify-section--header');
        if (h) {
          var headerRect = h.getBoundingClientRect();
          var headerStyle = window.getComputedStyle(h);
          var isHeaderSticky = headerStyle.position === 'sticky' || headerStyle.position === 'fixed';
          if (isHeaderSticky) {
            sectionElement.style.top = headerRect.bottom <= 0 ? '0px' : (h.offsetHeight + 'px');
          } else {
            sectionElement.style.top = '0px';
          }
        } else {
          sectionElement.style.top = '0px';
        }
      }
      window.addEventListener('scroll', updateStickyPosition);
      window.addEventListener('resize', updateStickyPosition);
      updateStickyPosition();
    }
  }

  function run() {
    var sections = document.querySelectorAll('.magnet-tab-wrapper');
    sections.forEach(function(section) {
      var sectionId = section.getAttribute('data-section-id');
      var enableSticky = section.getAttribute('data-enable-sticky') === 'true';
      if (sectionId) initSection(section, sectionId, enableSticky);
    });
  }

  if (typeof Swiper === 'undefined') {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(link);
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = run;
    document.head.appendChild(script);
  } else {
    run();
  }
})();
